import React from 'react';
import ReactDOM from 'react-dom';

import ReservationTriplePickerRealtime from '../reservationTriplePicker/reservationTriplePickerRealtime.jsx';

var ele = document.getElementById('rtp_div');

ReactDOM.render(
  <ReservationTriplePickerRealtime />,
  ele
);
